<template>
    <div class="other-info mt-4">
        <div :class="{
                'input-focus-effect': true,
                'rv-valiadate-input-form': error
            }">
            <textarea :class="other_info != '' ? 'border-primary' : ''" id="inputOtherInfo"
                v-model="other_info" @focus="forcusTextArer" rows="3"></textarea>
            <label :class="{
                    'mb-0': true,
                    'input-on-alue': other_info != ''
                }">Thông tin thêm</label>
        </div>
        <div class="text-danger fs-12px mt-1" v-if="error">{{error}}</div>
    </div>
</template>
<script>
export default {
    props: ['data', 'error'],
    data() {
        return {
            other_info: ''
        }
    },
    watch: {
        data(val){
            this.other_info = val;
        },
        other_info(val){
            this.$emit('update:data', val);
        }
    },
    created() {
        this.other_info = this.data;
    },
    methods : {
        forcusTextArer(){
            this.$emit('update:error', '');
        }
    }
}
</script>
<style lang="scss">
    .other-info{
        textarea{
            padding: 10px;
            border: 1px solid rgba(0, 0, 0, 0.2);
            display: block;
            width: 100%;
            border-radius: 4px;
            transition: border 0.15s linear;
            background-color: transparent;
            outline: none;
        }
    }
</style>